import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import "./assets/css/global.css"

import VueQrcodeReader from "vue-qrcode-reader"
Vue.use(VueQrcodeReader);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
